export default "__VITE_ASSET__CTUI4q6H__"